import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import Dashboard from '../../../../layouts/Dashboard';
import CreateMenu from '../../../../components/Global/Menus/Create';

interface Props extends RouteComponentProps {}

const CreateMenuOrg = ({ history }: Props): React.ReactElement => {
  const handleFinish = (id: string) => {
    history.push(`/org/menus/${id}`);
  };

  return (
    <>
      <Dashboard breadcrumbs={[{ label: 'Menus', link: `/org/menus` }, { label: 'Create' }]}>
        <CreateMenu handleFinish={handleFinish} />
      </Dashboard>
    </>
  );
};

export default withRouter(CreateMenuOrg);
